import * as yup from "yup";

// Unutar zagrada smiju stajati tokeni i razdjelnici, pa je i "{DD-YYYY}" ispravno (backend ga
// normalizira u "{DD}-{YYYY}", vidi DocumentNumberFormat).
const TOKEN_GROUP_REGEX = /\{([^{}]*)\}/g;
const TOKEN_GROUP_CONTENT_REGEX = /^(YYYY|YY|MM|DD|ID|[-/._ ])+$/;
const TOKEN_ID_REGEX = /ID/;

export const CONTRACT_SALE_EDIT_FORM_SCHEMA = yup.object().shape({
  contractSaleFormatNumber: yup
    .string()
    .required("Molimo Vas da unesete format broja ugovora")

    .test(
      "only-allowed-tokens",
      "Dozvoljeni su samo tokeni YYYY, YY, MM, DD i ID u vitičastim zagradama, npr. {ID/DD-YYYY} ili UG-{YYYY}-{ID}",
      (value) => {
        if (!value) return false;

        const groups = Array.from(value.matchAll(TOKEN_GROUP_REGEX));

        // mora postojati barem jedna zagrada, i svaka smije sadržavati samo tokene i razdjelnike
        return groups.length > 0
          && groups.every((group) => TOKEN_GROUP_CONTENT_REGEX.test(group[1]));
      }
    )

    // Bez rednog broja broj ovisi samo o datumu, pa bi dva dokumenta istog dana dobila isti broj.
    .test(
      "contains-id",
      "Format mora sadržavati {ID} (redni broj), npr. UG-{DD-YYYY}-{ID}. Bez njega brojevi nisu jedinstveni",
      (value) => {
        if (!value) return false;

        return Array.from(value.matchAll(TOKEN_GROUP_REGEX))
          .some((group) => TOKEN_ID_REGEX.test(group[1]));
      }
    ),
});